import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported,
  Analytics,
  setAnalyticsCollectionEnabled,
} from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCRpLxnFf2k-2p-5-NIaKrQDF0wLvESo4U",
  authDomain: "driver-web-app-592fe.firebaseapp.com",
  projectId: "driver-web-app-592fe",
  storageBucket: "driver-web-app-592fe.firebasestorage.app",
  messagingSenderId: "438276755809",
  appId: "1:438276755809:web:677f96d6cb5a158440f520",
  measurementId: "G-YFD8VP9DCG",
};

const app = initializeApp(firebaseConfig);

let analytics: Analytics | null = null;

export const initAnalytics = async () => {
  if (analytics) return;

  const supported = await isSupported();

  if (supported) {
    analytics = getAnalytics(app);
    setAnalyticsCollectionEnabled(analytics, true);
  }
};

export const getFirebaseAnalytics = () => analytics;
